import { Component, OnInit, Input } from '@angular/core';
import { SmtpConfigurationService } from 'src/app/service/smtp-configuration/smtp-configuration.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/service/shared/toast/toast.service';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

export class ownerInfo {
  from_address: string;
  from_name: string;
  smtp_server: string;
  smtp_port: string;
  smtp_username: string;
  smtp_password: string;
}

@Component({
  selector: 'app-smtp-configuration',
  templateUrl: './smtp-configuration.component.html',
  styleUrls: ['./smtp-configuration.component.scss'],
})
export class SmtpConfigurationComponent implements OnInit {
  smtpConfigurationForm: FormGroup;
  userPermissions;

  @Input() smtp_setting: any;

  constructor(
    private smtpConfigurationService: SmtpConfigurationService,
    private formBuilder: FormBuilder,
    private toastService: ToastService,
    // Still needed in order for getAndParseUserPermissions to work.
    private localStorageService: LocalstorageService,
  ) { }

  ngOnInit(): void {
    this.createForm();
    this.getSmtpConfiguration();
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
  }

  createForm(data = null) {
    if (data != null) {
      let newArray = {};
      data.forEach(element => {
        newArray[element.config_item] = element.config_value;
      });
      this.smtpConfigurationForm = this.formBuilder.group({
        from_address: [newArray['from_address'], Validators.required],
        from_name: [newArray['from_name'], Validators.required],
        smtp_server: [newArray['smtp_server'], Validators.required],
        smtp_port: [newArray['smtp_port'], Validators.required],
        smtp_username: [newArray['smtp_username'], Validators.required],
        smtp_password: [newArray['smtp_password'], Validators.required],
      });
    } else {
      this.smtpConfigurationForm = this.formBuilder.group({
        from_address: ['', Validators.required],
        from_name: ['', Validators.required],
        smtp_server: ['', Validators.required],
        smtp_port: ['', Validators.required],
        smtp_username: ['', Validators.required],
        smtp_password: ['', Validators.required],
      });
    }
  }

  onSubmit(form) {
    if (form.invalid) {
    } else {
      this.smtpConfigurationService.addUpdateSiteConfiguration(form.value).subscribe(res => this.onSuccess(res));
    }
  }

  onSuccess(res) {
    if (typeof res.data) {
      if (res.data) {
        this.toastService.showToast('SMTP configuration updated successfully', 'success');
        this.getSmtpConfiguration();
      }
    }
  }

  getSmtpConfiguration() {
    this.smtpConfigurationService.getSiteConfiguration(true, true).subscribe(
      res => this.onSmtpSuccess(res),
      error => this.onSmtpError(error),
    );
  }

  onSmtpSuccess(result) {
    if (result) {
      if (result.data) {
        this.createForm(result.data);
      }
    }
  }

  onSmtpError(error) { }
}
